<script setup lang="ts">
import { computed, onMounted, ref, toRef, watch } from 'vue'
import { useRoute, useRouter, withBase, useData } from 'vitepress'
import { getUrlParams } from '../utils'
import PostList from './PostList.vue'
import VPagination from './VPagination.vue'
import { Posts } from '../types/post'
interface Props {
  posts: Posts
  type?: string
  currentTypeVal?: string
}
const props = withDefaults(defineProps<Props>(), { posts: () => [], type: '' })
const posts = toRef(props, 'posts')
const currentPage = ref(1)
const blogContentTop = ref(0)
const perPage = 10

const postsOfCurrentPage = computed(() => {
  const start = (currentPage.value - 1) * perPage
  const end = currentPage.value * perPage

  return (posts.value || []).slice(start, end)
});

let handlePagation = (page: number) => {
    currentPage.value = page

    const homeHref = withBase(theme.value.home || route.path)
    router.go(
      page > 0
        ? `${homeHref}?${
            props.currentTypeVal ? `key=${props.currentTypeVal}&` : ''
          }page=${page}`
        : homeHref
    )

    window.setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: blogContentTop.value - 100,
        behavior: 'smooth',
      });
    }, 100)

}
const route = useRoute()
const router = useRouter()
const { theme } = useData()

let host = 'http://localhost'
router.onAfterRouteChanged = (to) => {
    currentPage.value = Number(getUrlParams(host + withBase(to), 'page') || 1)
  };
onMounted(() => {
  const location = window.location
  host = location.origin
  const blogContent = document.querySelector('.vp-blog__list')
  if (blogContent)
    blogContentTop.value = blogContent.getBoundingClientRect().top
  currentPage.value = Number(getUrlParams(location.href, 'page') || 1)
})
</script>
<template>
  <section class="flex-auto vp-blog__list">
    <PostList :data="postsOfCurrentPage" />
    <VPagination
      class="my-8 vp-blog__pagination"
      :currentPage="currentPage"
      :total="posts.length"
      @change="handlePagation"
    />
  </section>
</template>
